import { render } from "./ReceiveSmsQuickGuide.vue?vue&type=template&id=2a19779a&scoped=true"
const script = {}

import "./ReceiveSmsQuickGuide.vue?vue&type=style&index=0&id=2a19779a&scoped=true&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a19779a"]])

export default __exports__